module.exports = __webpack_public_path__ + "static/img/Ammonyte_Logo-13.a2cd12c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ammonyte_Logo-13.png
// module id = 262
// module chunks = 1